import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { SIGNUP } from '../../../_helpers/configuration';
import { SignupFlags } from '../../../../../sharedweb/app.structs';



@Injectable({
    providedIn: 'root'
})
export class SignupGuard  {
    constructor(
        private _router: Router
    ) { }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        const canLoadSignup = SIGNUP.toString() === SignupFlags.DEFAULT;
        if (canLoadSignup) {
            return canLoadSignup;
        }
        this._router.navigate(['login']);
        return false;
    }
}
